<template>
	<div class="news-block item">
		<div class="item-image">
			<nuxt-link :to="localePath(`/${item.filename}`)">
				<picture>
					<source :srcset="item.overviewImageWebp" type="image/webp" />
					<source :srcset="item.overviewImage" />
					<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
				</picture>
			</nuxt-link>
		</div>
		<div class="item-content">
			<h4>{{ item.title || item.header }}</h4>
			<p v-if="item.date">
				<strong>{{ $d(new Date(item.date.date.split(' ')[0]), 'short', locale) }}</strong>
			</p>
			<p>{{ item.overviewContent }}</p>
			<nuxt-link :to="localePath(`/${item.filename}`)">
				{{ $t('readMore') }}
			</nuxt-link>
		</div>
	</div>
</template>

<script setup>
const { locale } = useI18n();
const localePath = useLocalePath();

defineProps({
	item: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.item {
	display: flex;
	flex-flow: column wrap;
	margin: 0 auto 40px;

	p,
	h3 {
		margin-bottom: 10px;
	}

	.item-image,
	.item-content {
		width: 100%;
	}
}
</style>
